<div id="processing_gcp_map__map_container" data-testId="gcp-map"></div>
<div class="pane">
  <button nbTooltip="Fit the map extent to points" (click)="onResetMap()">
    <nb-icon icon="target" [pack]="CUSTOM_ICONS_PACK"></nb-icon>
  </button>
</div>
